export const css = {
	root: 'KuXHMba5',
	card: '_3PW0I1Dm',
	title: '_39FQ9LVl',
	activity_intro: '_2vwC4siW',
	teach_me: '_3d25j7K4',
	teach_me_tooltip: '_365vKlO8',
	quiz_me: '_3iD2ehCG',
	quiz_me_tooltip: '_2VyNolsS',
	icon: '_2J270Xqn',
	close: '_1R6uPiY7',
	skel: '_33PH3H94',
	skelWithTooltip: '_1-pcydtt',
	enter: '_1ZBh5eYJ',
	'slide-in': '_3880RlIY',
	exit: '_2E71-Sru',
	'slide-out': '_1g03s4Nu',
	expanded_content: 'oEQp0FEh',
	twoColumn: '_31Kzq4jR',
	shortDesc: '_3VvF_zqs',
	topicgroups: '_2bc_oe1U',
	item: '_2UKAMP55',
	topicquiz: '_1K3YVjdL',
	' _key': 'apic-theme/apic/card/expanded'
};

export default css;
